import { render, staticRenderFns } from "./ConfigurazioneGeneraleVociMenuListComponent.vue?vue&type=template&id=6f8f1778"
import script from "./ConfigurazioneGeneraleVociMenuListComponent.vue?vue&type=script&lang=js"
export * from "./ConfigurazioneGeneraleVociMenuListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports